<div class="d-flex align-items-center w-100">
    <p class="form-label-part font-weight-normal" style="font-size: 0.8rem" *ngIf="timestamp">{{timestamp}}</p>
    <lumi-button class="w-100" (onClick)="handleClickSend()"
        [icon]="'send'"
        [title]="'Reset gateway'"
        [label]="'Reset gateway'"
        [size]="'medium'">
    </lumi-button>
</div>
